import { IUser } from "../types/User";
import { apiClient } from "./apiClient";

const ENDPOINT = 'users';

export const getUsers = async (): Promise<IUser[]> => {
    return await apiClient(ENDPOINT, { method: 'GET' });
};

export const createUser = async (userData: Omit<IUser, 'id'>): Promise<IUser> => {
    return await apiClient(ENDPOINT, {
        method: 'POST',
        body: JSON.stringify(userData),
    });
};

export const updateUser = async (id: number, userData: Partial<IUser>): Promise<IUser> => {
    return await apiClient(`${ENDPOINT}/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(userData),
    });
};

export const deleteUser = async (id: number): Promise<boolean> => {
    await apiClient(`${ENDPOINT}/${id}`, { method: 'DELETE' });
    return true;
};